<template><div><code-well-header>
  <dt-image-viewer
    :image-src="$withBase('/assets/images/test.jpg')"
    image-alt="Image Alt Text"
    image-button-class="d-wmn64 d-hmn64 w-wmx332 d-hmx332"
    aria-label="Click to open image"
    close-aria-label="Close"
  />
</code-well-header>
<h2 id="examples" tabindex="-1" class="d-docsite--header-2">Examples <a class="header-anchor d-link d-docsite--link d-link" href="#examples" aria-hidden="true">#</a></h2>
<h3 id="jpg-image" tabindex="-1" class="d-docsite--header-3">JPG Image <a class="header-anchor d-link d-docsite--link d-link" href="#jpg-image" aria-hidden="true">#</a></h3>
<code-well-header>
  <dt-image-viewer
    ref="jpgExample"
    :image-src="$withBase('/assets/images/test.jpg')"
    image-alt="Image Alt Text"
    image-button-class="d-wmn64 d-hmn64 w-wmx332 d-hmx332"
    aria-label="Click to open image"
    close-aria-label="Close"
  />
</code-well-header>
<code-example-tabs
:htmlCode='() => $refs.jpgExample'
vueCode='
<dt-image-viewer
  image-src="url/to/image"
  image-alt="Image Alt Text"
  image-button-class="d-wmn64 d-hmn64 w-wmx332 d-hmx332"
  aria-label="Click to open image"
  close-aria-label="Close"
/>
'
/>
<h3 id="gif-image" tabindex="-1" class="d-docsite--header-3">GIF Image <a class="header-anchor d-link d-docsite--link d-link" href="#gif-image" aria-hidden="true">#</a></h3>
<code-well-header>
  <dt-image-viewer
    ref="gifExample"
    :image-src="$withBase('/assets/images/fry.gif')"
    image-alt="Image Alt Text"
    image-button-class="d-wmn64 d-hmn64 w-wmx332 d-hmx332"
    aria-label="Click to open image"
    close-aria-label="Close"
  />
</code-well-header>
<code-example-tabs
:htmlCode='() => $refs.gifExample'
vueCode='
<dt-image-viewer
  image-src="/url/to/gif"
  image-alt="Image Alt Text"
  image-button-class="d-wmn64 d-hmn64 w-wmx332 d-hmx332"
  aria-label="Click to open image"
  close-aria-label="Close"
/>
'
/>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="imageviewer" /></div></template>


